import React from "react";
import { FORM_BUILDER_FIELD_TYPE, INPUT_RADIO_FIELD_TYPES, LabelString, ButtonIcon, ICONS, PrimaryButton, ButtonSizeOptions, LabelDollarFormatted, LabelPercentFormatted } from "@loanbossinc/component-library";
import styled from "styled-components";

import { hasRecourseSchedule, shouldShowSendNotificationList, isNew } from "./section-loan-guarantor-rows-logic";

const StyledPill = styled.span`&&{
  padding-left: 11px;
  width: 71px;
  height: 28px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: uppercase;  
  color:#FFFFFF;
  background: #0F9AD6;
  border-radius: 4px;
}`;
const StyledLabelDollarFormatted = styled(LabelDollarFormatted)`&&{
  float: left;
}`;
const StyledLabelPercentFormatted = styled(LabelPercentFormatted)`&&{
  float: left;
}`;
const StyledNoData = styled.span`&&{
  float: left;
}`;
const StyledButtonWrapper = styled.div`&&{  
  display: flex;
  float: right;
}`;

const markComplete = (loan, customConditon, startSave) => {
  customConditon.isComplete = !customConditon.isComplete;
  startSave(loan);
};

const generateDetailsConfig = (loan, index, schedulesIndex, startSave) => {
  const config = [
    { label: "Debt Yield", path: "debtYield", style: {}, formatting: value => (<StyledLabelPercentFormatted value={value / 100} lines={1} />) },
    { label: "Occupancy", path: "occupancy", style: {}, formatting: value => (<StyledLabelPercentFormatted value={value / 100} lines={1} />) }
  ];

  const hasCustomConditon = loan &&
                            loan.companyGuarantors[index] &&
                            loan.companyGuarantors[index].guarantorRecourseSchedules &&
                            loan.companyGuarantors[index].guarantorRecourseSchedules[schedulesIndex] &&
                            loan.companyGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions &&
                            loan.companyGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions.length > 0;
  if (hasCustomConditon) {
    for (let i = 0; i < loan.companyGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions.length; i++) {
      const path = `guarantorRecourseScheduleCustomConditions[${i}].condition`;
      const customConditon = loan.companyGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions[i];
      const condition = customConditon.condition;
      const isComplete = customConditon.isComplete;
      config.push({
        label: `${condition}`,
        path,
        style: {},
        formatting: value => (<>{`${isComplete ? "Complete" : "Incomplete"}`}</>),
        action: value => (<PrimaryButton
          style={{ float: "right" }}
          label={`Mark as ${isComplete ? "Incomplete" : "Complete"}`}
          onClick={() => markComplete(loan, customConditon, startSave)}
          size={ButtonSizeOptions.smFluid}
        />)
      });
    }
  }

  return config;
};

export const rows = (loan, props, isQuote, startSave, goBack, openDrawer, deleteItem, expandRow, schedulesIndex) => ({
  title: {
    label: "Company Guarantor",
    isTitle: true,
    buttonLabel: "Remove",
    onTitleButtonClick: data => {
      const current = data.values;
      current.companyGuarantors = current.companyGuarantors.filter(x => x.id !== current.companyGuarantors[props].id);
      startSave(current, goBack);
    },
    titleButtonStyle: { color: "#C40A0A", float: "right" }
  },
  guarantorCompanyName: {
    label: "Guarantor Name",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: `companyGuarantors[${props}].companyName`,
        variant: "filled"
      }
    ]
  },
  netWorth: {
    label: "Net Worth",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: `companyGuarantors[${props}].netWorth`,
        variant: "filled"
      }
    ]
  },
  liquidity: {
    label: "Liquidity",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: `companyGuarantors[${props}].liquidity`,
        variant: "filled"
      }
    ]
  },
  leverage: {
    label: "Leverage",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: `companyGuarantors[${props}].leverage`,
        variant: "filled",
        decimals: 3
      }
    ]
  },
  burndown: {
    label: "Burndown",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: `companyGuarantors[${props}].burndownRaw`,
        label: "Yes",
        altlabel: "No",
        hideLabel: true
      }
    ]
  },
  notes: {
    label: "Notes",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: `companyGuarantors[${props}].notes`,
        variant: "filled",
        multiline: true
      }
    ]
  },
  reference: {
    label: "Reference",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: `companyGuarantors[${props}].reference`,
        variant: "filled"
      }
    ]
  },
  hasRecourseSchedule: {
    isVisible: data => !isNew(data.companyGuarantors[props]),
    label: "Recourse Schedule",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH_INDI,
        name: `companyGuarantors[${props}].hasRecourseSchedule`,
        label: "Yes",
        altlabel: "No",
        hideLabel: true,
        onClick: (prevValue, formik) => {
          if (!prevValue) {
            const companyGuarantors = formik.values.companyGuarantors;
            companyGuarantors[props].hasRecourseSchedule = !prevValue;
            let guarantorRecourseSchedules = companyGuarantors[props].guarantorRecourseSchedules;

            if (!guarantorRecourseSchedules || guarantorRecourseSchedules.length === 0) {
              guarantorRecourseSchedules = [
                {
                  id: "new",
                  guarantorId: companyGuarantors[props].id,
                  sortOrder: 0,
                  isCurrent: 1,
                  recourseType: "recoursePercentRadio",
                  recoursePercent: 100,
                  guarantorRecourseScheduleCustomConditions: []
                },
                {
                  id: "new",
                  guarantorId: companyGuarantors[props].id,
                  sortOrder: 1,
                  guarantorRecourseScheduleCustomConditions: []
                }
              ];
            } else {
              guarantorRecourseSchedules.push({
                id: "new",
                guarantorId: companyGuarantors[props].id,
                sortOrder: guarantorRecourseSchedules.length,
                guarantorRecourseScheduleCustomConditions: []
              });
            }

            companyGuarantors[props].guarantorRecourseSchedules = guarantorRecourseSchedules;

            formik.setValues({ ...formik.values, companyGuarantors });
            startSave(formik.values);
          }
        }
      }
    ]
  },
  recourse: {
    isVisible: data => !hasRecourseSchedule(data.companyGuarantors[props]),
    label: "Recourse Amount",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.INPUTRADIOFIELD,
        handleRadioButtonChange: (formik, items, value) => {
          formik.setFieldValue(`companyGuarantors[${props}].recourseType`, value);
        },
        radioValue: `companyGuarantors[${props}].recourseType`,
        radioButtons: [
          {
            name: "recourseAmountRadio",
            fieldName: `companyGuarantors[${props}].recourseAmount`,
            handleChange: (formik, fieldName, value) => {
              formik.setFieldValue(fieldName, value);
            },
            label: "Fixed Amount ($)",
            decimals: 2,
            inputFormatt: INPUT_RADIO_FIELD_TYPES.DOLLAR
          },
          {
            name: "recoursePercentRadio",
            fieldName: `companyGuarantors[${props}].recoursePercent`,
            handleChange: (formik, fieldName, value) => {
              formik.setFieldValue(fieldName, value);
            },
            label: "% of Loan Balance",
            decimals: 2,
            inputFormatt: INPUT_RADIO_FIELD_TYPES.PERCENT
          }
        ]
      }
    ]
  },
  recourseSchedule: {
    isVisible: data => hasRecourseSchedule(data.companyGuarantors[props]),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TABLE,
        columns: [
          {
            id: "recourseObligation",
            label: "Recourse Obligation",
            align: "center",
            alignHeader: "left",
            Cell: (value, isSelected) => {
              switch (value.recourseType) {
                case "recourseAmountRadio":
                  return (<StyledLabelDollarFormatted value={value.recourseAmount} decimals={2} lines={1} isSelected={isSelected} />);
                case "recoursePercentRadio":
                  return (<StyledLabelPercentFormatted value={value.recoursePercent / 100} decimals={2} lines={1} isSelected={isSelected} />);
                default:
                  return (<StyledNoData>--</StyledNoData>);
              }
            }
          },
          {
            id: "dscr",
            label: "DSCR",
            path: "dscr",
            alignHeader: "center",
            Cell: (value, isSelected) => <LabelString value={value} isSelected={isSelected} />
          },
          {
            id: "ltv",
            label: "LTV",
            path: "ltv",
            alignHeader: "center",
            Cell: (value, isSelected) => <LabelString value={value} isSelected={isSelected} />
          },
          {
            id: "button",
            path: "",
            alignHeader: "center",
            width: "25%",
            Cell: (value, isSelected) => (<StyledButtonWrapper>
              {value.isCurrent && (<StyledPill>CURRENT</StyledPill>)}
              <ButtonIcon disabled={value.id === "new"} onClick={() => openDrawer(value, props, "companyGuarantors")} iconName="create" />
              {value.sortOrder !== 0 && <ButtonIcon disabled={value.id === "new"} onClick={() => deleteItem(value, props, "companyGuarantors")} iconName="delete" />}
              <ButtonIcon onClick={() => expandRow(value, props, "companyGuarantors")} iconName={value.isExpanded ? ICONS.UNFOLD_LESS : ICONS.UNFOLD_MORE} />
                                          </StyledButtonWrapper>)
          }
        ],
        itemsRootPath: `companyGuarantors[${props}].guarantorRecourseSchedules`,
        items: [],
        hideHeader: false,
        addDropShodow: false,
        detailsConfig: generateDetailsConfig(loan, props, schedulesIndex, startSave)

      },
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON_PRIMARY,
        label: "Add Row",
        hideLabel: true,
        size: ButtonSizeOptions.smFluid,
        onClick: (value, formik) => {
          const companyGuarantors = formik.values.companyGuarantors;
          let guarantorRecourseSchedules = companyGuarantors[props].guarantorRecourseSchedules;

          if (!guarantorRecourseSchedules || guarantorRecourseSchedules.length === 0) {
            guarantorRecourseSchedules = [
              {
                id: "new",
                guarantorId: companyGuarantors[props].id,
                sortOrder: 0,
                isCurrent: 1,
                recourseType: "recoursePercentRadio",
                recoursePercent: 100,
                guarantorRecourseScheduleCustomConditions: []
              },
              {
                id: "new",
                guarantorId: companyGuarantors[props].id,
                sortOrder: 1,
                guarantorRecourseScheduleCustomConditions: []
              }
            ];
          } else {
            guarantorRecourseSchedules.push({
              id: "new",
              guarantorId: companyGuarantors[props].id,
              sortOrder: guarantorRecourseSchedules.length,
              guarantorRecourseScheduleCustomConditions: []
            });
          }

          companyGuarantors[props].guarantorRecourseSchedules = guarantorRecourseSchedules;

          formik.setValues({ ...formik.values, companyGuarantors });
          startSave(formik.values);
        },
        style: { marginTop: "10px", float: "right" }
      }
    ]
  },
  burnup: {
    isVisible: data => hasRecourseSchedule(data.companyGuarantors[props]),
    label: "Burnup",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: `companyGuarantors[${props}].burnup`,
        label: "Yes",
        altlabel: "No",
        hideLabel: true
      }
    ]
  },
  shouldSendNotification: {
    isVisible: data => hasRecourseSchedule(data.companyGuarantors[props]),
    label: "Issue a notification when recourse exposure changes",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: `companyGuarantors[${props}].shouldSendNotification`,
        label: "Yes",
        altlabel: "No",
        hideLabel: true
      },
      {
        isVisible: data => shouldShowSendNotificationList(data.companyGuarantors[props]),
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: `companyGuarantors[${props}].guarantorRecourseExposureNotificationContacts`,
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option &&
                        option.length > 0 &&
                        option.map(x => x.contactId),
        parentId: "contacts",
        optionIdPath: "contactId",
        onChange: (selectedItems, formik) => {
          const companyGuarantors = formik.values.companyGuarantors;
          let contacts = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            contacts = selectedItems.map(x => ({ id: x, guarantorId: companyGuarantors[props].id, contactId: x }));
            companyGuarantors[props].guarantorRecourseExposureNotificationContacts = contacts;
          }
          formik.setValues({ ...formik.values, companyGuarantors });
        }
      }
    ]
  }
});

